import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/allireland-logo.webp")